import {
  FETCH_PRICE_LISTS,
  FETCH_PRICE_LISTS_DETAIL,
  COMPARE_PRICE_LISTS,
  PRICE_LIST_SUBMIT,
  OFFER_ITEMS_LIST_SUBMIT,
  FETCH_PRICES_LIST_ERRORS,
  FETCH_PRICES,
  REPROCESS_PRICE,
} from "./types";
import * as API from "./api";

// --------------------------------------------------------------------------
// FETCH_PRICE_LISTS
// --------------------------------------------------------------------------
export const fetchPriceLists = (page, vendor, dateFrom, dateTo) => ({
  type: FETCH_PRICE_LISTS.init,
  payload: API.fetchPriceLists(page, vendor, dateFrom, dateTo),
});

export const fetchPriceListsSuccess = (info) => ({
  type: FETCH_PRICE_LISTS.success,
  payload: info,
});

export const fetchPriceListsFailure = (error) => ({
  type: FETCH_PRICE_LISTS.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_PRICES_LIST_DETAIL
// --------------------------------------------------------------------------
export const fetchPricesListDetail = (id) => ({
  type: FETCH_PRICE_LISTS_DETAIL.init,
  payload: API.fetchPricesListDetail(id),
});

export const fetchPricesListDetailSuccess = (info) => ({
  type: FETCH_PRICE_LISTS_DETAIL.success,
  payload: info,
});

export const fetchPricesListDetailFailure = (error) => ({
  type: FETCH_PRICE_LISTS_DETAIL.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_PRICES_LIST_PRICES
// --------------------------------------------------------------------------
export const fetchPrices = (id, search, businessType, page) => ({
  type: FETCH_PRICES.init,
  payload: API.fetchPrices(id, search, businessType, page),
});

export const fetchPricesSuccess = (info) => ({
  type: FETCH_PRICES.success,
  payload: info,
});

export const fetchPricesFailure = (error) => ({
  type: FETCH_PRICES.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// FETCH_PRICES_LIST_ERRORS
// --------------------------------------------------------------------------
export const fetchPricesListErrors = (id, search, page) => ({
  type: FETCH_PRICES_LIST_ERRORS.init,
  payload: API.fetchPricesListErrors(id, search, page),
});

export const fetchPricesListErrorsSuccess = (info) => ({
  type: FETCH_PRICES_LIST_ERRORS.success,
  payload: info,
});

export const fetchPricesListErrorsFailure = (error) => ({
  type: FETCH_PRICES_LIST_ERRORS.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// REPROCESS_PRICE
// --------------------------------------------------------------------------
export const reprocessPrice = (data) => ({
  type: REPROCESS_PRICE.init,
  payload: API.reprocessPrice(data),
});

export const reprocessPriceSuccess = (data) => ({
  type: REPROCESS_PRICE.success,
  payload: data,
});

export const reprocessPriceFailure = (error) => ({
  type: REPROCESS_PRICE.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// PRICE_LIST_SUBMIT
// --------------------------------------------------------------------------
export const pricesListSubmit = (data) => ({
  type: PRICE_LIST_SUBMIT.init,
  payload: API.pricesListSubmit(data),
});

export const pricesListSubmitSuccess = (data) => ({
  type: PRICE_LIST_SUBMIT.success,
  payload: data,
});

export const pricesListSubmitFailure = (error) => ({
  type: PRICE_LIST_SUBMIT.failure,
  payload: error,
});

// --------------------------------------------------------------------------
// COMPARE_PRICES_LIST
// --------------------------------------------------------------------------
export const comparePricesLists = (ids, page, brand, businessType, search, comparisonType) => ({
  type: COMPARE_PRICE_LISTS.init,
  payload: API.comparePriceLists(ids, page, brand, businessType, search, comparisonType),
});

export const comparePricesListsSuccess = (info) => ({
  type: COMPARE_PRICE_LISTS.success,
  payload: info,
});

export const comparePricesListsFailure = (error) => ({
  type: COMPARE_PRICE_LISTS.failure,
  payload: error,
});
